import React from 'react';
import classes from './MRadio.module.scss';

type Props = {
  inputRef?: React.RefObject<HTMLInputElement>;
  id?: string;
  name: string;
  checked: boolean;
  value?: React.InputHTMLAttributes<HTMLInputElement>['value'];
  className?: string;
  disabled?: boolean;
  onChange: (value: React.ChangeEvent<HTMLInputElement>) => void;
  onClick: () => void;
};

const MRadioView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <div className={classes['container']}>
      <button
        type="button"
        className={`${classes['btn']} ${props.className} ${props.disabled ? classes['btn--disabled'] : ''}`.trim()}
        disabled={props.disabled}
        name={props.name}
        onClick={props.onClick}
      >
        <div
          className={`${classes['box']} ${props.checked && !props.disabled ? classes['box--checked'] : ''} ${props.className || ''}`.trim()}
        ></div>
        <input
          ref={props.inputRef}
          className={classes['input']}
          type="radio"
          name={props.name}
          id={props.id}
          value={props.value}
          checked={props.checked}
          disabled={props.disabled}
          onChange={props.onChange}
        />
      </button>
    </div>
  );
};

MRadioView.displayName = 'MRadioView';
MRadioView.defaultProps = {};

export default MRadioView;
